import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { INews } from '../../models/INews';
import { IResponse } from '../../models/IResponse';
import { HttpPaths } from '../../models/Enums/http-paths';
import { CommonHttpService } from '../shard/common-http.service';
import { BranchItem, IBranchesAndSocial, SocialItem } from '../../models/ibranches-and-social';

@Injectable({
  providedIn: 'root'
})
export class ContactService {

  private _http = inject(CommonHttpService);
  
  // Centralized sorting order for social platforms
  private readonly socialOrder = [
    'facebook',
    'instagram',
    'x',
    'twitter',
    'linkedin',
    'youtube',
    'whatsapp',
    'telegram',
    'tiktok',
    'snapchat',
    'pinterest'
  ];

  constructor() {}

  getSOCIAL(): Observable<IBranchesAndSocial<SocialItem[]>> {
    return this._http.CommonGetRequests(
      environment.baseUrl + HttpPaths.GET_SOCIAL_LINKS
    );
  }

  getSortedSocialLinks(): Observable<SocialItem[]> {
    return this.getSOCIAL().pipe(
      map(data => {
        const items = data?.value || [];
        return [...items].sort((a, b) => {
          const platformA = (a?.platform || '').toLowerCase();
          const platformB = (b?.platform || '').toLowerCase();
          const idxA = this.socialOrder.indexOf(platformA);
          const idxB = this.socialOrder.indexOf(platformB);
          if (idxA !== -1 && idxB !== -1) return idxA - idxB;
          if (idxA !== -1) return -1;
          if (idxB !== -1) return 1;
          return platformA.localeCompare(platformB);
        });
      })
    );
  }

  getBRANCHES(): Observable<IBranchesAndSocial<BranchItem[]>> {
    return this._http.CommonGetRequests(
      environment.baseUrl + HttpPaths.GET_BRANCHES
    );
  }
}
